import React from 'react';
import SensorTypesPage from './SensorTypesPage';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';
import { configureActions } from '../../../../actions/configure.action';
import Backend from '../../../Layouts/Backend';
import Loading from '../../../Helpers/Loading';
import helper from '../../../../utils/helper';
import lookupActions from '../../../../actions/lookup.actions';
import { bindActionCreators } from 'redux';

const textCenter = { textAlign: 'center', whiteSpace: 'nowrap' };

class SensorTypes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      departments: [],
      sensorTypes: [],
      loading: false,
      errors: [],
      openModal: false,
      selectedRow: null,
      deptId: undefined,
    };
    this.columns = [
      {
        dataField: 'typeName',
        text: 'Type Name',
        sort: true,
        headerStyle: { width: 100, whiteSpace: 'nowrap' },
      },
      {
        dataField: 'alarmDelay',
        text: 'Delay',
        sort: true,
        headerStyle: textCenter,
        align: 'center',
      },
      {
        dataField: 'decimalPrecision',
        text: 'DP',
        sort: true,
        headerStyle: textCenter,
        align: 'center',
      },
      {
        dataField: 'units',
        text: 'Units',
        sort: true,
        headerStyle: textCenter,
        align: 'center',
      },
      {
        dataField: 'lowAlarmInOperation',
        text: '<<',
        sort: true,
        headerStyle: textCenter,
        align: 'center',
        headerTitle: () => 'Low Alarm',
        formatter: (cell, row) =>
          this.lowHighFormatter(row.lowAlarmInOperation, row.lowAlarmAtRest),
      },
      {
        dataField: 'lowWarningInOperation',
        text: '<',
        sort: true,
        headerStyle: textCenter,
        align: 'center',
        headerTitle: () => 'Low Warning',
        formatter: (cell, row) =>
          this.lowHighFormatter(
            row.lowWarningInOperation,
            row.lowWarningAtRest,
          ),
      },
      {
        dataField: 'highWarningInOperation',
        text: '>',
        sort: true,
        headerStyle: textCenter,
        align: 'center',
        headerTitle: () => 'High Warning',
        formatter: (cell, row) =>
          this.lowHighFormatter(
            row.highWarningInOperation,
            row.highWarningAtRest,
          ),
      },
      {
        dataField: 'highAlarmInOperation',
        text: '>>',
        sort: true,
        headerStyle: textCenter,
        align: 'center',
        headerTitle: () => 'High Alarm',
        formatter: (cell, row) =>
          this.lowHighFormatter(row.highAlarmInOperation, row.highAlarmAtRest),
      },
      {
        dataField: 'normalLogTimeInOperation',
        text: 'Normal Log',
        headerStyle: textCenter,
        align: 'center',
        formatter: (cell, row) =>
          this.lowHighFormatter(
            row.normalLogTimeInOperation,
            row.normalLogTimeAtRest,
          ),
      },
      {
        dataField: 'alarmTimeInOperation',
        text: 'Alarm Log',
        headerStyle: textCenter,
        align: 'center',
        formatter: (cell, row) =>
          this.lowHighFormatter(
            row.alarmTimeInOperation,
            row.alarmLogTimeAtRest,
          ),
      },
      {
        dataField: 'parameter',
        text: 'Parameter',
        sort: true,
        headerStyle: textCenter,
      },
      {
        dataField: 'commLossTime',
        text: 'Comm Loss',
        sort: true,
        headerStyle: textCenter,
        align: 'center',
      },
      {
        dataField: 'chartMin',
        text: 'Chart Min',
        sort: true,
        headerStyle: textCenter,
        align: 'center',
      },
      {
        dataField: 'chartMax',
        text: 'Chart Max',
        sort: true,
        headerStyle: textCenter,
        align: 'center',
      },
      {
        dataField: 'chartUnits',
        text: 'Calc. Units',
        sort: true,
        headerStyle: textCenter,
        align: 'center',
      },
      {
        dataField: 'calcDecimalPrecision',
        text: 'Calc DP',
        sort: true,
        headerStyle: textCenter,
        align: 'center',
      },
      {
        dataField: 'calcChartMin',
        text: 'Calc Chart Min',
        sort: true,
        headerStyle: textCenter,
        align: 'center',
      },
      {
        dataField: 'calcChartMax',
        text: 'Calc Chart Max',
        sort: true,
        headerStyle: textCenter,
        align: 'center',
      },
      {
        dataField: 'includeInBatchReports',
        text: 'In Batch',
        headerStyle: textCenter,
        align: 'center',
        sort: true,
        formatter: (cell) => {
          if (cell) {
            return 'Yes';
          } else {
            return 'No';
          }
        },
        filterValue: (cell) => {
          if (cell) {
            return 'Yes';
          } else {
            return 'No';
          }
        },
      },
    ];
    this.defaultSorted = [
      {
        dataField: 'id',
        order: 'asc',
      },
    ];
    this.ctxMenuOptions = [
      [
        {
          name: 'Edit sensor type',
          action: (row, rowIndex) => {
            this.props.history.push(
              `/configure/sensor-types/edit-sensor-type/${row.id}`,
            );
          },
        },
        {
          name: 'Copy sensor type',
          action: (row, rowIndex) => {
            this.props.history.push(
              `/configure/sensor-types/new-sensor-type/${this.state.deptId}?copiedFrom=${row.id}`,
            );
          },
        },
        {
          name: 'Delete sensor type',
          action: (row, rowIndex) => {
            this.setState({ openModal: true, selectedRow: row });
          },
        },
      ],
    ];
  }
  lowHighFormatter = (inOpt, atRest) => (
    <div title="In Operation / At Rest">
      {`${inOpt ? inOpt : ''}/${atRest ? atRest : ''}`}
    </div>
  );
  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    if (nextProps.configure.sensorTypes !== prevState.sensorTypes) {
      state.sensorTypes = nextProps.configure.sensorTypes;
    }
    if (nextProps.lookup.departments !== prevState.departments) {
      state.departments = nextProps.lookup.departments;
    }
    if (nextProps.configure.loading !== prevState.loading) {
      state.loading = nextProps.configure.loading;
    }
    // const userDept = helper.parseQueryString(nextProps.location.search).deptId;
    // if (userDept && parseInt(userDept) !== state.deptId) {
    //   state.deptId = parseInt(userDept);
    // }
    // console.log(userDept, 'userDept');
    state.errors = helper.centralizeError([
      nextProps.configure.errors,
      nextProps.lookup.errors,
    ]);
    return Object.keys(state).length ? state : null;
  }
  async componentDidMount() {
    await this.props.configureActions.getSensorTypes();
    this.props.lookupActions.getDepartments().then((resp) => {
      let deptId = helper.parseQueryString(this.props.location.search).deptId;
      if (deptId) {
      } else {
        deptId = helper.getUserDepartment(resp).deptId;
      }
      this.setState({ deptId: parseInt(deptId) });
      this.props.history.replace(`/configure/sensor-types?deptId=${deptId}`);
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const propsDept = helper.parseQueryString(
      this.props.location.search,
    ).deptId;
    if (propsDept && parseInt(propsDept) !== this.state.deptId) {
      this.setState({ deptId: parseInt(propsDept) });
    }
  }

  onCancel = () => {
    this.setState({ openModal: false, selectedRow: null });
  };

  onDeleteSensorType = () => {
    const { selectedRow } = this.state;
    this.setState(
      { openModal: false },
      async () =>
        await this.props.configureActions
          .deleteSensorType(selectedRow.id)
          .then(async () => await this.props.configureActions.getSensorTypes()),
    );
  };

  render() {
    if (this.state.loading) {
      return (
        <Backend>
          <Loading />
        </Backend>
      );
    }
    return (
      <SensorTypesPage
        {...this.state}
        datagridProps={{
          columns: this.columns,
          defaultSorted: this.defaultSorted,
        }}
        ctxMenuOptions={this.ctxMenuOptions}
        onCancel={this.onCancel}
        onDeleteSensorType={this.onDeleteSensorType}
        onChangeDept={(deptId) =>
          this.props.history.push(`/configure/sensor-types?deptId=${deptId}`)
        }
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    configure: state.configure,
    lookup: state.lookup,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    lookupActions: bindActionCreators(
      Object.assign({}, lookupActions),
      dispatch,
    ),
    configureActions: bindActionCreators(
      Object.assign({}, configureActions),
      dispatch,
    ),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(SensorTypes);
